import { render } from "./SideMenuTitle.html?vue&type=template&id=206f4675&scoped=true&ts=true&external"
import script from "./SideMenuTitle.vue?vue&type=script&lang=ts"
export * from "./SideMenuTitle.vue?vue&type=script&lang=ts"

import "./SideMenuTitle.scss?vue&type=style&index=0&id=206f4675&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206f4675"]])

export default __exports__